import {
    NonVerifiedUserAccount,
    UserAccount,
    VerifiedUserAccount,
    VerifyRequestResponse,
} from "./interfaces"

export function createVerifiedUserAccount(data: VerifyRequestResponse): VerifiedUserAccount {
    return {
        kind: "verified",
        ...data,
    }
}

export function createNonVerifiedUserAccount(): NonVerifiedUserAccount {
    return {
        kind: "nonVerified",
        allowed_referral_program: false,
        allowed_deposit_purchase: false,
        allowed_knowledge_base_access: false,
        hide_card_payment: false,
        hide_phone: false,
        allowed_manage_cards: false,
        telegram_account: null,
        psychologists: [],
        completed_surveys: 0,
        is_hr: false,
        is_b2b: false,
        show_discount_amount: false,
    }
}

export function isVerified(data: UserAccount): data is VerifiedUserAccount {
    return data.kind === "verified"
}
